import { render, staticRenderFns } from "./MainBusinessDetails.vue?vue&type=template&id=6045cd14&scoped=true"
import script from "./MainBusinessDetails.vue?vue&type=script&lang=js"
export * from "./MainBusinessDetails.vue?vue&type=script&lang=js"
import style0 from "./MainBusinessDetails.vue?vue&type=style&index=0&id=6045cd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6045cd14",
  null
  
)

export default component.exports